import Vue from "vue";
import VueRouter from "vue-router";
import Book from "../components/book/Book.vue";
import BookEdit from "../components/book/BookEdit.vue";
import Department from "@/components/department/Department";
import DepartmentEdit from "@/components/department/DepartmentEdit";
import CategoryEdit from "@/components/category/CategoryEdit";
import Category from "@/components/category/Category";
import Login from "@/components/Login";

Vue.use(VueRouter);

export default new VueRouter({
    mode: "hash",
    routes: [
        {
            path: "/book",
            name: 'book',
            component: Book,
        },
        {
            path: "/book-edit/:id",
            name: 'book-edit',
            component: BookEdit,
            props: {
                default: true,
            },
        },
        {
            path: "/book-edit",
            name: 'book-add',
            component: BookEdit,
        },
        {
            path: "/department",
            name: 'department',
            component: Department,
        },
        {
            path: "/department-edit/:id",
            name: 'department-edit',
            component: DepartmentEdit,
            props: {
                default: true,
            },
        },
        {
            path: "/department-edit",
            name: 'department-add',
            component: DepartmentEdit,
        },
        {
            path: "/category",
            name: 'category',
            component: Category,
        },
        {
            path: "/category-edit/:id",
            name: 'category-edit',
            component: CategoryEdit,
            props: {
                default: true,
            },
        },
        {
            path: "/category-edit",
            name: 'category-add',
            component: CategoryEdit,
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/*',
            redirect: '/login'
        },
    ],
});
